/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * a base for entity order
 * @export
 * @interface InternalApiEntityOrder
 */
export interface InternalApiEntityOrder {
    /**
     * Unique identifier (external id or code etc)
     * @type {string}
     * @memberof InternalApiEntityOrder
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiEntityOrder
     */
    order: number;
}

/**
 * Check if a given object implements the InternalApiEntityOrder interface.
 */
export function instanceOfInternalApiEntityOrder(value: object): value is InternalApiEntityOrder {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    return true;
}

export function InternalApiEntityOrderFromJSON(json: any): InternalApiEntityOrder {
    return InternalApiEntityOrderFromJSONTyped(json, false);
}

export function InternalApiEntityOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiEntityOrder {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'order': json['order'],
    };
}

export function InternalApiEntityOrderToJSON(json: any): InternalApiEntityOrder {
    return InternalApiEntityOrderToJSONTyped(json, false);
}

export function InternalApiEntityOrderToJSONTyped(value?: InternalApiEntityOrder | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'order': value['order'],
    };
}

